export default "<p>recovery-passwd works!</p>\r\n"